

// Styles.js
const styles = {
  label: {
    color: "var(--ui-text-muted)",
    marginRight: "8px",
    fontWeight: "bold",
  },
  loading: {
    width: "80vw",
    height: "40vh",
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  },
  pageContainer: {
    display: "flex",
    gap: "10px",
    fontFamily: "'Roboto', sans-serif",
    overflow: "hidden",
  },
  mainContent: {
    flex: 1,
    padding: "30px",
    background: "transparent",
    position: "relative",
    overflowY: "visible",
  },
  contentWrapper: {
    padding: "20px",
    backgroundColor: "var(--ui-bg)",
    borderRadius: "20px",
    position: "relative", // Убедимся, что родительский элемент не ограничивает z-index
    // zIndex: 1, // Базовый z-index для всего контейнера
  },
  header: {
    fontSize: "24px",
    fontWeight: "bold",
    // marginBottom: "20px",
    color: "var(--ui-text)",
  },
  navBar: {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
    alignItems: "center",
  },
  addButton: {
    marginBottom: "10px",
    padding: "8px 16px",
    backgroundColor: "var(--ui-success)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s",
  },
  dropdownWrapper: {
    position: "relative",
  },
  dropdown: {
    padding: "8px",
    border: "1px solid var(--ui-border)",
    borderRadius: "4px",
    fontSize: "14px",
    backgroundColor: "var(--ui-surface)",
    cursor: "pointer",
    width: "200px",
  },
  dropdownDisabled: {
    backgroundColor: "var(--ui-surface-hover)",
    cursor: "not-allowed",
  },
  dropdownSkeleton: {
    width: "200px",
    height: "34px",
    backgroundColor: "var(--ui-border)",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite",
  },
  tableContainer: {
    backgroundColor: "var(--ui-surface)",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    overflow: "visible", // Убедимся, что контейнер таблицы не обрезает dropdown
    position: "relative",
    zIndex: 2, // Увеличиваем z-index
  },
  tableWrapper: {
    transition: "opacity 0.5s ease-in-out",
    position: "relative",
    overflow: "visible", // Убедимся, что wrapper не обрезает dropdown
    zIndex: 3, // Увеличиваем z-index
    paddingBottom: "20px"
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "12px",
    backgroundColor: "var(--ui-surface-alt)",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "14px",
    color: "var(--ui-text)",
    borderBottom: "1px solid var(--ui-border)",
    "&:first-child": {
      width: "40%", // Категория и наименование
    },
    "&:nth-child(2)": {
      width: "100%", // Параметры
    },
    "&:last-child": {
      width: "20%", // Действия
    },
    "&:nth-child(even)": {
      backgroundColor: "var(--ui-surface-alt)",
    },
    "&:hover": {
      backgroundColor: "var(--ui-surface-hover)",
    },
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid var(--ui-border)",
    fontSize: "14px",
    color: "var(--ui-text)",
    "&:first-child": {
      width: "40%",
    },
    "&:nth-child(2)": {
      width: "40%",
    },
    "&:last-child": {
      width: "20%",
      textAlign: "center",
    },
    position: "relative",
    overflow: "visible", // Убедимся, что ячейка не обрезает dropdown
    zIndex: 4, // Увеличиваем z-index
  },
  tr: {
    position: "relative",
    overflow: "visible", // Убедимся, что строка не обрезает dropdown
  },
  editInput: {
    padding: "6px",
    border: "1px solid var(--ui-border)",
    borderRadius: "4px",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
    "&:focus": {
      borderColor: "var(--ui-primary)",
      boxShadow: "0 0 0 2px rgba(0,123,255,0.2)",
    },
  },
  cellContent: {
    cursor: "pointer",
  },
  flexDiv: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: "10px"
  },
  dropdownItem: {
    padding: "8px 12px",
    cursor: "pointer",
    backgroundColor: "var(--ui-surface)",
    color: "var(--ui-text)",
    fontSize: "14px",
    borderBottom: "1px solid var(--ui-border)",
    whiteSpace: "normal",
    wordWrap: "break-word",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "var(--ui-surface-hover)",
    },
    "&.selected": {
      backgroundColor: "var(--ui-primary-soft)",
      "&:hover": {
        backgroundColor: "var(--ui-primary-soft)",
      },
    },
  },
  editInput: {
    position: "relative",
    zIndex: 1000, // Высокий z-index, чтобы поле было поверх других элементов
    backgroundColor: "var(--ui-surface)", // Белый фон для контраста
    border: "2px solid var(--ui-primary)", // Яркая синяя рамка для выделения
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)", // Тень для эффекта поднятия
    padding: "4px 8px",
    fontSize: "14px",
    borderRadius: "4px",
    width: "100%", // Поле занимает всю ширину ячейки
    outline: "none", // Убрать стандартный outline браузера
    transition: "border-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
    animation: "fadeInInput 0.2s ease-out", // Плавное появление
  },
  cellContent: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "50px",
    padding: "4px 8px",
    minHeight: "40px",
    cursor: "pointer", // Указывает, что ячейка кликабельна
  },
  "@keyframes fadeInInput": {
    "0%": { opacity: 0, transform: "scale(0.95)" },
    "100%": { opacity: 1, transform: "scale(1)" },
  },
  editTextarea: {
    padding: "6px",
    border: "1px solid var(--ui-border)",
    borderRadius: "4px",
    fontSize: "14px",
    resize: "vertical",
    minHeight: "60px",
  },
  resetButton: {
    padding: "6px 12px",
    backgroundColor: "var(--ui-success)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s",
  },
  saveButton: {
    padding: "6px 12px",
    backgroundColor: "var(--ui-success)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s",
  },
  cancelButton: {
    padding: "6px 12px",
    backgroundColor: "var(--ui-danger)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s",
  },
  deleteButton: {
    padding: "6px 12px",
    backgroundColor: "var(--ui-danger)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s",
  },
  showMoreContainer: {
    textAlign: "center",
    padding: "20px",
  },
  showMoreButton: {
    padding: "8px 16px",
    backgroundColor: "var(--ui-primary)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "var(--ui-surface)",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    width: "400px",
    maxWidth: "90%",
    zIndex: 1001,
  },
  modalTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "var(--ui-text)",
  },
  modalText: {
    fontSize: "14px",
    marginBottom: "20px",
    color: "var(--ui-text-muted)",
  },
  modalButtons: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
  },
  modalConfirmButton: {
    padding: "8px 16px",
    backgroundColor: "var(--ui-success)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  modalCancelButton: {
    padding: "8px 16px",
    backgroundColor: "var(--ui-danger)",
    color: "var(--ui-surface)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  skeletonWrapper: {
    padding: "12px",
  },
  skeletonRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "12px",
  },
  skeletonCell: {
    flex: 1,
    height: "20px",
    backgroundColor: "var(--ui-border)",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite",
  },
  error: {
    color: "var(--ui-danger)",
    textAlign: "center",
    padding: "20px",
  },
  noData: {
    textAlign: "center",
    padding: "20px",
    color: "var(--ui-text-muted)",
  },
};

export default styles;